import React, { ReactNode } from 'react'
import cx from 'classnames'
import CustomButton from 'UI/Button/Button'
import './Button.scss'

export interface IButton {
  className?: string
  to?: string
  children?: ReactNode
  onClick?: () => void
  disabled?: boolean
  buttonType?: 'primary' | 'secondary' | 'icon' | 'secondary-icon' | 'transparent'
  icon?: ReactNode
  activeClassName?: string
}

export default function Button(props: IButton) {
  const { to, className, buttonType = 'primary', icon, activeClassName, ...rest } = props

  return (
    <CustomButton
      to={to}
      className={cx(className)}
      buttonType={buttonType}
      icon={icon}
      activeClassName={activeClassName}
      {...rest}
    />
  )
}
